import { LoginPageModel, LoginPageStatus } from "./login-page-model";

export function updatePageModelForStatusChangeReducer(
  pageModel: LoginPageModel,
  pageStatus: LoginPageStatus
): LoginPageModel {
  let {
    title,
    informationMessages,
    buttonTitle,
    showResendVerificationButton: showResendVerificationCodeButton,
    subStatus,
    showButton,
    showFooter
  } = pageModel;
  switch (pageStatus) {
    case "Ready":
      buttonTitle = "Continue";
      showResendVerificationCodeButton = false;
      subStatus = "Ready";
      showButton = true;
      showFooter = true;
      break;
    case "Sending":
      title = "Please wait";
      informationMessages = ["Sending details to confirm account"];
      buttonTitle = "Sending";
      showResendVerificationCodeButton = false;
      showButton = true;
      showFooter = true;
      break;
    case "Succeeded":
      title = "Success";
      buttonTitle = "Continue";
      showResendVerificationCodeButton = false;
      showButton = true;
      showFooter = true;
      break;
    case "Failed":
      // see login-response-code-helper for failure messages..
      buttonTitle = "Retry";
      showButton = true;
      showFooter = true;
      break;
    case "Missing Query Parameters":
      title = "Not Authorised";
      buttonTitle = "";
      informationMessages = ["Unable to determine client application."];
      showButton = false;
      showFooter = false;
      break;
  }
  return updatePageModelReducer(pageModel, {
    title,
    informationMessages,
    buttonTitle,
    showResendVerificationButton: showResendVerificationCodeButton,
    subStatus,
    showButton,
    showFooter
  });
}

export function updatePageModelReducer(
  pageModel: LoginPageModel,
  updateModel: Partial<LoginPageModel>
): LoginPageModel {
  return { ...pageModel, ...updateModel };
}
